module.exports = __webpack_public_path__ + "promotion_strong.png?9e0d6a4faacac76c407308d64f0167ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promotion_strong.png
// module id = 998
// module chunks = 2